import { IFormEventHandlerFn } from '../../../../SingleGridForm/office-form/models/form-event-handler.model';
import { PREarnCodeFieldsEnum } from '../../enums/fields/PREarnCodeFields.enum';
import { PREarnCodeMethodConstants } from '../../enums/forms-data/pr-earn-code.enums';
import { IBaseEventArgs } from '../../../../models/modal-form-metadata.model';
import { OfficeFieldsValuesObj } from '../../../../models/office-data.model';

export class BeforeTabChangeEventHandler extends IFormEventHandlerFn {
  static message = "Subject earnings only available when method is 'R' (Routine) or 'L' (Allowance).";
  static subjectEarningsTabIndex = 5;
  static handle({ formData, toTab }: { formData: OfficeFieldsValuesObj; toTab?: number }): IBaseEventArgs | null {
    const method = formData[PREarnCodeFieldsEnum.Method];
    if (
      toTab === this.subjectEarningsTabIndex &&
      method !== PREarnCodeMethodConstants.Routine &&
      method !== PREarnCodeMethodConstants.Allowance
    ) {
      return {
        error: this.message,
        isCanceled: true,
      };
    }
    return null;
  }
}
